import Mousetrap from "mousetrap";
import PropTypes from "prop-types";
import React from "react";
import { Row, Checkbox, Col, Form, FormGroup, FormControl } from "react-bootstrap";
import _ from "lodash";

import AccountActions from "../actions/AccountActions";

import CurrencyStore from "../stores/CurrencyStore";
import UserStore from "../stores/UserStore";

export default class AccountEdit extends React.Component
{
	constructor(props)
	{
		super(props);

		this.state = AccountEdit.getStoreState();

		const account = JSON.parse(JSON.stringify(props.account));
		this.state.account = account;
		this.state.errors = null;

		this._onChange = this._onChange.bind(this);
		this.handleAccountSave = this.handleAccountSave.bind(this);
		this.handleAccountNameChange = this.handleAccountNameChange.bind(this);
		this.handleAccountCurrencyChange = this.handleAccountCurrencyChange.bind(this);
		this.handleAccountTypeChange = this.handleAccountTypeChange.bind(this);
	}

	static getStoreState()
	{
		var updatedState = {};

		if (UserStore.areMultipleCurrenciesEnabled())
		{
			updatedState.areMultipleCurrenciesEnabled = true;
			updatedState.currencies = CurrencyStore.getCurrencies();
		}

		return updatedState;
	}

	async handleAccountSave(event)
	{
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		this.setState({ errors: null });
		try
		{
			await AccountActions.saveAccount(this.state.account);
			this.props.onAccountSave();
		}
		catch (err)
		{
			let errors = null;
			if (err && err.response && err.response.body) {
				errors = err.response.body;
			}
			this.setState({ errors });
		}
	}

	handleAccountNameChange(event)
	{
		const account = JSON.parse(JSON.stringify(this.state.account));
		account.name = event.target.value;

		this.setState({ account });
	}

	handleAccountCurrencyChange(event)
	{
		const account = JSON.parse(JSON.stringify(this.state.account));
		account.currencyId = +event.target.value;
		if (account.currencyId === 0)
		{
			account.currencyId = null;
		}

		this.setState({ account });
	}

	handleAccountActiveChange(event)
	{
		const account = JSON.parse(JSON.stringify(this.state.account));
		account.hideIfEmpty = !account.hideIfEmpty;

		this.setState({ account });
	}

	handleAccountTypeChange(event)
	{
		const account = JSON.parse(JSON.stringify(this.state.account));
		account.type = +event.target.value;

		this.setState({ account });
	}

	// Method to setState based upon Store changes
	_onChange()
	{
		this.setState(AccountEdit.getStoreState());
	}

	componentDidUpdate()
	{
		if (this.props && this.props.account && this.props.account.id !== this.state.account.id)
		{
			const account = JSON.parse(JSON.stringify(this.props.account));
			this.setState({ account, errors: null });
		}
	}

	componentDidMount()
	{
		Mousetrap.bind("mod+s", "Save", () => { this.handleAccountSave(); return false; });
		if (this.state.areMultipleCurrenciesEnabled || UserStore.areMultipleCurrenciesEnabled())
		{
			CurrencyStore.addChangeListener(this._onChange);
		}
	}

	componentWillUnmount()
	{
		Mousetrap.unbind("mod+s");
		if (this.state.areMultipleCurrenciesEnabled || UserStore.areMultipleCurrenciesEnabled())
		{
			CurrencyStore.removeChangeListener(this._onChange);
		}
	}

	render()
	{
		const { account, currencies, errors } = this.state;

		// Currency change is prevented if there are any transactions
		// The simplest way to determine that client side is by the amount
		// However we could have multiple transactions that sum to 0
		const currencyChangeDisabled = typeof account.amount === "number" && account.amount !== 0;

		return (
			<Form horizontal onSubmit={this.handleAccountSave}>
				<FormGroup>
					<Row>
						<Col sm={2}>
							Name
						</Col>
						<Col sm={10}>
							<FormControl id="accountName" type="text" placeholder="Name" className="mousetrap-mod" value={account.name || ""} onChange={this.handleAccountNameChange}/>
						</Col>
					</Row>
				</FormGroup>
				{currencies &&
					<FormGroup>
						<Row>
							<Col sm={2}>
								Currency
							</Col>
							<Col sm={10}>
								<FormControl
									id="accountCurrency"
									componentClass="select"
									placeholder="Currency"
									className="mousetrap-mod"
									value={account.currencyId || ""}
									onChange={this.handleAccountCurrencyChange}
									disabled={currencyChangeDisabled}
								>
									<option></option>
									{currencies.map(currency => {
										return (
											<option key={currency.id} value={currency.id}>
												{currency.name}
											</option>
										);
									})}
								</FormControl>
							</Col>
						</Row>
					</FormGroup>
				}
				<Row>
					<Col sm={4}>
					<Checkbox
							checked={!account.hideIfEmpty}
							onChange={this.handleAccountActiveChange.bind(this)}
						>
							Active
						</Checkbox>
					</Col>
					<Col sm={8}>
						Inactive accounts with no balance will be hidden from the transactions page.
					</Col>
				</Row>
				{errors && _.keys(errors).map(fieldName => {
					let errorMessages = errors[fieldName];
					return (
						<p key={fieldName} className="text-danger">
							<span>{fieldName}: </span>
							{errorMessages.map((msg, msgIndex) => {
								return (
									<span key={msgIndex}>{msg}</span>
								);
							})}
						</p>
					);
				})}
				<button type="button" className="btn btn-primary" onClick={this.handleAccountSave}>Save</button>
			</Form>
		);
	}
}

AccountEdit.defaultProps = {
	onAccountSave: () => {}
};

AccountEdit.propTypes = {
	account: PropTypes.object,
	onAccountSave: PropTypes.func
};



// WEBPACK FOOTER //
// ./Components/components/AccountEdit.jsx